import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/overview").then((module) => ({
    default: module.AdminOverview,
  })),
);

export const Route = createFileRoute("/admin/")({
  component: Page,
});
